export default __webpack_public_path__ + "static/report-content-08-bd5310737b32649e424c404a526a3083.png";